import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { ViewUserDataContract, UserDataInteractorOutputContract } from 'src/app/1.contracts/user.data.contract';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { EntityLandingPageForm } from 'src/app/5.transversal/5.1.entity/entity.landing.page.form';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, UrlTree, DefaultUrlSerializer } from '@angular/router';
import { ComponentDialogAlert } from '../view.components/component.dialog.alert/component.dialog.alert';
import { UtilTitle, UtilMessages } from 'src/app/5.transversal/5.2.utils/util.constants';
import { ComponentDialogAlertType } from '../view.components/component.dialog.alert/component.dialog.alert.interface';
import { ComponentDialogTerms } from '../view.components/component.dialog.terms/component.dialog.terms';
import { UserDataInteractor } from 'src/app/3.interactor/user.data.interactor';
import { ComponentDialogSchedule } from '../view.components/component.dialog.schedule/component.dialog.schedule';
import { ComponentDialogScheduleProperties } from '../view.components/component.dialog.schedule/component.dialog.schedule.properties';
import { EntityScheduleSetting } from 'src/app/5.transversal/5.1.entity/entity.schedule.setting';
import { EntityDataToCall } from 'src/app/5.transversal/5.1.entity/entity.data.to.call';

@Component({
    templateUrl: './view.user.data.html',
    styleUrls: ['./view.user.data.css']
})
export class ViewUserData implements
    AfterViewInit,
    OnInit,
    ViewUserDataContract,
    UserDataInteractorOutputContract {

    ngAfterViewInit(): void { }

    public formUserData: FormGroup;
    public checkboxColor: string = 'primary';
    public labelCheckPosition: string = 'after';
    public scheduleSettingData: EntityScheduleSetting = null;
    public showFirstButtons: boolean = true;
    public showAsesor: boolean = false;
    public paramsPage: any = null;
    public planId: number = 1;
    public asesor = false;


    public formGroup: EntityLandingPageForm = {
        fieldName: new FormControl('', [Validators.required]),
        fieldCellPhone: new FormControl('', [Validators.required]),
        fieldEmail: new FormControl('', [Validators.required]),
        fieldTerms: new FormControl(false, [Validators.required]),
        fieldType: new FormControl(1)
    };

    constructor(
        private formBuilder: FormBuilder,
        private spinner: NgxSpinnerService,
        private interactor: UserDataInteractor,
        private dialog: MatDialog,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        this.interactor.interactorOutput = this;
        this.formUserData = this.formBuilder.group(this.formGroup);
        this.spinner.show();
    }

    parse(url: any): UrlTree {
        let dus = new DefaultUrlSerializer();
        return dus.parse(url);
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params != null) {
                this.paramsPage = JSON.stringify(params);
            }
            let currentDate: Date = new Date();
            this.interactor.getScheduleSettingList(
                currentDate.getDate(),
                (currentDate.getMonth() + 1),
                currentDate.getFullYear(),
                currentDate.getDay(),
                this.planId
            );
        });
    }



    scheduleSettingListSuccessfulOutput(data: EntityScheduleSetting): void {
        this.spinner.hide();
        this.scheduleSettingData = data;

        var _currentDate = new Date();
        var _initDate = new Date(this.scheduleSettingData.year, (this.scheduleSettingData.month - 1), this.scheduleSettingData.day, this.scheduleSettingData.initHour, this.scheduleSettingData.initMinute, 0, 0);
        var _finalDate = new Date(this.scheduleSettingData.year, (this.scheduleSettingData.month - 1), this.scheduleSettingData.day, this.scheduleSettingData.finalHour, this.scheduleSettingData.finalMinute, 0, 0);

        if (_currentDate >= _initDate && _currentDate <= _finalDate) {
            this.showFirstButtons = true;
            this.formGroup.fieldType.setValue(1);
        } else {
            this.showFirstButtons = false;
            this.formGroup.fieldType.setValue(2);
        }
    }

    scheduleSettingListFailureOutput(): void {
        this.onFailureLoad();
    }

    onClickScheduleCall(): void {
        if (
            this.formGroup.fieldName.valid &&
            this.formGroup.fieldCellPhone.valid &&
            this.formGroup.fieldEmail.valid
        ) {
            const expression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            const emailValid: boolean = expression.test(this.formGroup.fieldEmail.value);
            var cellphoneValid: boolean = this.formGroup.fieldCellPhone.value != null && this.formGroup.fieldCellPhone.value != undefined && this.formGroup.fieldCellPhone.value.toString().length == 10 && this.formGroup.fieldCellPhone.value.toString().charAt(0) == 3;
            var formValid: boolean = emailValid && cellphoneValid;

            if (formValid) {
                if (this.formGroup.fieldTerms.value) {
                    this.spinner.show();
                    var dataToCall: EntityDataToCall = {
                        name: this.formGroup.fieldName.value,
                        params: this.paramsPage,
                        cellphone: this.formGroup.fieldCellPhone.value,
                        email: this.formGroup.fieldEmail.value,
                        timeToCall: 0,
                        callMeNow: this.formGroup.fieldType.value
                    };
                    if (this.formGroup.fieldType.value == 1) {
                        this.interactor.sendUserData(dataToCall);
                    } else {
                        var dataDialog: ComponentDialogScheduleProperties = {
                            dataToCall: dataToCall,
                            scheduleDate: this.scheduleSettingData,
                            params: this.paramsPage
                        };
                        this.dialog.open(ComponentDialogSchedule, {
                            data: dataDialog,
                            disableClose: true
                        }).afterClosed().subscribe(dialogResponse => {
                            this.interactor.interactorOutput = this;
                            if (dialogResponse) {
                                this.sendUserDataSuccessfulOutput();
                            }
                        });
                    }
                } else {
                    this.dialog.open(ComponentDialogAlert, {
                        data: {
                            title: UtilTitle.Error,
                            message: UtilMessages.aceptTerms,
                            buttonText: 'Aceptar',
                            type: ComponentDialogAlertType.Error,
                            stopProcess: false
                        },
                        disableClose: true
                    });
                }
            } else {
                if (emailValid == false) {
                    this.formGroup.fieldEmail.setErrors({ 'incorrect': true })
                    this.dialog.open(ComponentDialogAlert, {
                        data: {
                            title: UtilTitle.Error,
                            message: UtilMessages.dataIncompleteEmail,
                            buttonText: 'Aceptar',
                            type: ComponentDialogAlertType.Error,
                            stopProcess: false
                        },
                        disableClose: true
                    });
                }
                else if (cellphoneValid == false) {
                    this.formGroup.fieldCellPhone.setErrors({ 'incorrect': true });
                    this.dialog.open(ComponentDialogAlert, {
                        data: {
                            title: UtilTitle.Error,
                            message: UtilMessages.dataIncompleteCellphone,
                            buttonText: 'Aceptar',
                            type: ComponentDialogAlertType.Error,
                            stopProcess: false
                        },
                        disableClose: true
                    });
                }
            }
        } else {
            this.dialog.open(ComponentDialogAlert, {
                data: {
                    title: UtilTitle.Error,
                    message: UtilMessages.dataIncomplete,
                    buttonText: 'Aceptar',
                    type: ComponentDialogAlertType.Error,
                    stopProcess: false
                },
                disableClose: true
            });
        }
    }

    sendUserDataSuccessfulOutput(): void {
        this.formUserData.reset();
        Object.keys(this.formUserData.controls).forEach(key => {
            this.formUserData.get(key).setErrors(null);
        });
        this.spinner.hide();
        this.dialog.open(ComponentDialogAlert, {
            data: {
                title: UtilTitle.Success,
                message: UtilMessages.dataSuccessful,
                buttonText: 'Aceptar',
                type: ComponentDialogAlertType.Success,
                stopProcess: false
            },
            disableClose: true
        }).afterClosed().subscribe(dialogResponse => {
            window.location.href = 'https://digitalk-xtracking.s3.us-east-2.amazonaws.com/index.html?1=1';
        });
    }

    sendUserDataFailureOutput(): void {
        this.spinner.hide();
        this.dialog.open(ComponentDialogAlert, {
            data: {
                title: UtilTitle.Error,
                message: UtilMessages.genericError,
                buttonText: 'Aceptar',
                type: ComponentDialogAlertType.Error,
                stopProcess: false
            },
            disableClose: false
        });
    }

    openDialogTerms() {
        this.dialog.open(ComponentDialogTerms);
    }

    // openPDF(){
    //     window.open('https://www.colmedica.com/DocumentosPublicos/Protecci%C3%B3n%20de%20datos/Manual-Politica-Tratamiento-Datos-Personales-2020.pdf');
    // }

    private onFailureLoad() {
        this.spinner.hide();
        this.dialog.open(ComponentDialogAlert, {
            data: {
                title: UtilTitle.Error,
                message: UtilMessages.errorParameters,
                buttonText: 'Aceptar',
                type: ComponentDialogAlertType.Error,
                stopProcess: true
            },
            disableClose: true
        });
    }

}